import { BiSolidSun, BiSolidMoon } from "react-icons/bi";
import { HiMenuAlt3, HiMenuAlt1 } from "react-icons/hi";
import { FaShoppingCart, FaUserCircle } from "react-icons/fa"; // Import the profile icon
import ResponsiveMenu from "./ResponsiveMenu";
import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { getUser } from "../Utility/getUser"; // Import the getUser function

export const Navlinks = [
  {
    id: 1,
    name: "HOME",
    link: "/",
  },
  {
    id: 2,
    name: "AUTOS",
    link: "/cars",
  },
  {
    id: 3,
    name: "ÜBER UNS",
    link: "/#about",
  },
];

const Navbar = ({ theme, setTheme, cartCount }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [user, setUser] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    setUser(null);
    window.location.href = "/signin";
  };

  useEffect(() => {
    const loggedInUser = getUser();
    setUser(loggedInUser);
  }, []);

  return (
    <div className="relative z-10 shadow-md w-full dark:bg-black dark:text-white duration-300">
      <div className="container py-2 md:py-0">
        <div className="flex justify-between items-center">
          <div>
            <span className="text-3xl font-bold font-serif">MietWagen</span>
          </div>
          <nav className="hidden md:block">
            <ul className="flex items-center gap-8">
              {Navlinks.map(({ id, name, link }) => (
                <li key={id} className="py-4">
                  <a
                    href={link}
                    className="text-lg font-medium hover:text-red-500 py-2 hover:border-b-2 hover:border-red-500 transition-colors duration-500"
                  >
                    {name}
                  </a>
                </li>
              ))}
              {/* Cart icon */}
              <li className="py-4 relative">
                <a
                  href="/cart"
                  className="text-lg font-medium hover:text-red-500 py-2 transition-colors duration-500"
                >
                  <FaShoppingCart className="text-2xl" />
                  {cartCount > 0 && (
                    <span className="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-red-100 bg-red-600 rounded-full">
                      {cartCount}
                    </span>
                  )}
                </a>
              </li>
              {/* Profile or Login */}
              <li
                className="py-4 relative hidden md:block" // Hide in mobile mode
                onMouseEnter={() => setShowDropdown(true)}
                onMouseLeave={() => setShowDropdown(false)}
              >
                {user ? (
                  <>
                    <a
                      href="/profile"
                      className="text-lg font-medium hover:text-red-500 py-2 transition-colors duration-500"
                    >
                      <FaUserCircle className="text-2xl" />
                    </a>
                    {showDropdown && (
                      <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-md shadow-lg py-2 z-20">
                        <a
                          href="/dashboard"
                          className="block px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
                        >
                          Dashboard
                        </a>
                        <a
                          href="/myfavorite"
                          className="block px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
                        >
                          My Favorite
                        </a>
                        <button
                          onClick={handleLogout}
                          className="block w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
                        >
                          Logout
                        </button>
                      </div>
                    )}
                  </>
                ) : (
                  <a
                    href="/signin"
                    className="text-lg font-medium hover:text-red-500 py-2 transition-colors duration-500"
                  >
                    Login
                  </a>
                )}
              </li>
              {/* DarkMode feature implement */}
              {theme === "dark" ? (
                <BiSolidSun
                  onClick={() => setTheme("light")}
                  className="text-2xl hover:text-red-500"
                />
              ) : (
                <BiSolidMoon
                  onClick={() => setTheme("dark")}
                  className="text-2xl hover:text-red-500"
                />
              )}
            </ul>
          </nav>
          {/* Mobile view */}
          <div className="flex items-center gap-4 md:hidden">
            {/* dark mode */}
            {theme === "dark" ? (
              <BiSolidSun
                onClick={() => setTheme("light")}
                className="text-2xl hover:text-red-600"
              />
            ) : (
              <BiSolidMoon
                onClick={() => setTheme("dark")}
                className="text-2xl hover:text-red-600"
              />
            )}
            {/* Cart icon */}
            <a
              href="/cart"
              className="text-lg font-medium hover:text-red-600 py-2 transition-colors duration-500 relative"
            >
              <FaShoppingCart className="text-2xl" />
              {cartCount > 0 && (
                <span className="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-red-100 bg-red-600 rounded-full">
                  {cartCount}
                </span>
              )}
            </a>
            {/* Mobile Hamburger icon */}
            {showMenu ? (
              <HiMenuAlt1
                onClick={toggleMenu}
                className="cursor-pointer transition-all hover:text-red-600"
                size={30}
              />
            ) : (
              <HiMenuAlt3
                onClick={toggleMenu}
                className="cursor-pointer transition-all hover:text-red-600"
                size={30}
              />
            )}
          </div>
        </div>
      </div>
      <ResponsiveMenu showMenu={showMenu} />
    </div>
  );
};

Navbar.propTypes = {
  theme: PropTypes.string.isRequired,
  setTheme: PropTypes.func.isRequired,
  cartCount: PropTypes.number.isRequired,
};

export default Navbar;
